import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import page from '@/pages/page'
import index from '@/pages/index'
import error from '@/pages/error'

Vue.use(Router);

let router = new Router({
        // linkActiveClass: 'is-active',
        base: '/salenet/', //第二層
        routes: [
            {
                path: '',
                component: page,
                meta: {
                    requiresAuth: false,
                    requiresLogin: false
                },
                children: [
                    {
                        path: '',
                        component: index
                    },
                    {
                        path: '/index',
                        name: 'index',
                        component: index
                    },
                    {
                        path: '/error',
                        name: 'error',
                        component: error
                    }
                ]
            },
            {
                path: '/system',
                component: page,
                meta: {
                    requiresAuth: true,
                    requiresLogin: true
                },
                children: [
                    {
                        path: 'productList',
                        component: resolve => require(['@/pages/productList'], resolve),
                        props: {
                            class: '',
                            product: '',
                            item: '',
                            page: 1,
                        }
                    },
                    {
                        path: 'cartList',
                        component: resolve => require(['@/pages/cartList'], resolve),
                    },
                    {
                        path: 'orderInfo',
                        component: resolve => require(['@/pages/orderInfo'], resolve),
                        props: {
                            inqtno: '',
                            caption: '',
                        }
                    },
                    {
                        path: 'search',
                        component: resolve => require(['@/pages/search'], resolve),
                    },
                    {
                        path: 'account',
                        component: resolve => require(['@/pages/account'], resolve),
                        props: {
                            page: '',
                            tab: '',
                            table: '',
                            start: '',
                            end: '',
                        }
                    },
                    {
                        path: 'signup',
                        component: resolve => require(['@/pages/signup'], resolve),
                    },
                    {
                        path: 'materialPrice',
                        component: resolve => require(['@/pages/materialPrice'], resolve),
                    },
                    {
                        path: 'video',
                        component: resolve => require(['@/pages/video'], resolve),
                    },
                ]
            },
            {
                path: '/*',
                redirect: '/error'
            }
        ],
        scrollBehavior: function(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                return { x: 0, y: 0 }
            }
        }
    })

router.beforeEach((to, from, next) => {
    store.commit('clearStatus');
    store.commit('isLoadingChange', 'reset');

    next();
});

export default router;
